import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import SectorsHeatmap from './SectorsHeatmap';
import SectionError from '../SectionError';
import { TimeSpentDropdown, timeSpentMetrics } from '../MetricLists';
import SimpleCard from '../../../../components/Card/SimpleCard';
import OverPeriodDropdown from '../../../../components/OverPeriodDropdown';
import { sectorsStatsSelector } from '../../selectors';
import { fetchSectorsStats } from '../../actions';

const SectorsStat = () => {
  const dispatch = useDispatch();

  const { data, settings, filters } = useSelector(sectorsStatsSelector);

  const [segment, setSegment] = useState(Object.keys(timeSpentMetrics)[0]);

  const handlePeriodChange = (value) => {
    dispatch(fetchSectorsStats({ change_type: value }));
  };

  if (settings.error) return <SectionError />;

  return (
    <SimpleCard
      headerLeft={
        <>
          <h3 className="h3 header-heading">AI User Impact by Sector</h3>

          <p className="header-description">
            Highlights how time spent by medium and high-frequency AI users is changing across
            sectors and where their attention is concentrated.
          </p>
        </>
      }
      actionsLeft={<div className="highcharts-watermark" />}
      contentDisableGutters
      className="sectors-stats-card"
    >
      <header className="sectors-stats-card__body-header">
        <div className="sectors-stats-card__body-header-left">
          <TimeSpentDropdown selected={segment} onChange={setSegment} />
        </div>
        <div className="sectors-stats-card__body-header-right">
          <OverPeriodDropdown
            selected={filters.change_type}
            disabled={settings.pending}
            menuAlign="end"
            onChange={handlePeriodChange}
          />
        </div>
      </header>
      <SectorsHeatmap
        months={data.months}
        data={data.sectors?.[segment]}
        isPending={settings.pending}
      />
    </SimpleCard>
  );
};

export default SectorsStat;
